import { useEffect, useState } from 'react'

import { API_URL, isvApi } from '../services/api'

const useDownloadTerms = (hashCode) => {
    const [file, setFile] = useState(null)
    const [isLoadingFile, setIsLoadingFile] = useState(false)

    useEffect(() => {
        const fetchFile = async () => {
            setIsLoadingFile(true)
            const response = await isvApi.get(`${API_URL.confidentTerms}?hash=${hashCode}`)
            const blob = new Blob([response.data], {type: 'application/pdf', encoding: 'UTF-8'})
            setFile(window.URL.createObjectURL(blob))
            setIsLoadingFile(false)
        }

        if (hashCode) {
            fetchFile()
        }

        return () => {
            setFile(null)
            setIsLoadingFile(false)
        }
    }, [hashCode])

    return [file, isLoadingFile]
}

export default useDownloadTerms
